import { api } from '../api';
import { useMutation, UseMutationResult } from 'react-query';
import { isMock } from '../utilities/is-mock';
import { AxiosError } from 'axios';

type UseGroupsConfig = {
    page?: number;
    limit?: number;
    search: string;
    sort: string;
    filter: string;
};

/**
 * Request a csv of the accounts for a chart and automatically trigger a download.
 * @param entityId
 * @param chartId
 */
export async function download({ page, limit, search, sort, filter }: UseGroupsConfig): Promise<void> {
    try {
        const query = isMock()
            ? `filter=${filter}&page=${page}&sort=${sort}&search=${search}&limit=${limit}`
            : `${filter}&page=${page}&${sort}&search=${encodeURIComponent(search)}&limit=${limit}`;

        const response = await api.get(`/groups/download?${query}`, {
            responseType: 'blob',
            headers: { Accept: 'text/csv' },
        });

        // Create URL and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'groups.csv');
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        throw new Error((error as AxiosError).response?.data?.message || 'Failed to download CSV. Please try again.');
    }
}

export function useExportGroups({
    page,
    limit,
    search,
    sort,
    filter,
}: UseGroupsConfig): UseMutationResult<void, AxiosError, void, unknown> {
    return useMutation(() => download({ page, limit, search, sort, filter }));
}
